export const stringToArrayBuffer = (str: number) => {
  const length = str.toString().length;
  const buffer = new ArrayBuffer(length * 2);
  const bufferView = new Uint16Array(buffer);
  for (let i=0; i < length; i++) {
    bufferView[i] = str.toString().charCodeAt(i);
  }
  return buffer;
};
